import { Review } from "./review.feature";

export default Review;
